import React from "react";
import { useTranslation } from "react-i18next";
import SectionComponent from "../../../../components/utils/SectionComponent";
import "./cardFraudList.scss";

function CardFraudList() {
  const { t } = useTranslation()

  return (
    <div className="container-card-fraud-list">
      <div className="texts-card-fraud-list">
        <SectionComponent title={t("ecommerce.card_fraud_list.fraud.title")} text={t("ecommerce.card_fraud_list.fraud.section_text")} />

        <SectionComponent title={t("ecommerce.card_fraud_list.logistics.title")} text={t("ecommerce.card_fraud_list.logistics.section_text_1")}>
          <p>{t("ecommerce.card_fraud_list.logistics.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("ecommerce.card_fraud_list.reverse_logistics.title")} text={t("ecommerce.card_fraud_list.reverse_logistics.section_text_1")}>
          <p>{t("ecommerce.card_fraud_list.reverse_logistics.section_text_2")}</p>
        </SectionComponent>


        <SectionComponent title={t("ecommerce.card_fraud_list.churn.title")} text={t("ecommerce.card_fraud_list.churn.section_text_1")}>
          <p>{t("ecommerce.card_fraud_list.churn.section_text_2")}</p>
          <p>{t("ecommerce.card_fraud_list.churn.section_text_3")}</p>
        </SectionComponent>
      </div>
    </div>
  );
}

export default CardFraudList;
